import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

import { Table, message, Spin, Statistic } from "antd";

//Component import
import ReportLayout from "../../../../pageLayouts/Report";
import { fetchApi, fetchExcelApi } from "../../../../../services/api";
//import MultiTable from "../MultiTableDataEntryStatus";
import MultiTable from "../DataEntryStatusReport120Days/Multitable";
import Empty from "../../../../components/Custom/Empty";

//Utility
import { sortFunction } from "../../../../../utility/sorter";
import { mapKeys, isEmpty, cloneDeep } from "lodash";
import moment from "moment";
import { formatDate } from "../../../../../utility/date";
import { parseData } from "./parseData";

class DataEntryStatusReportEmasculation extends Component {
  componentRef = React.createRef();
  state = {
    data: null,
    loading: false,
    blockNoList: [],
    block_uuid: null,
    blockNumber: null,
    ActivityMonth: null
  };

  componentDidMount() {
    this.fetchBlockNo();
  }

  fetchDataEntryEmasculation = () => {
    let { block_uuid, ActivityMonth } = this.state;
    if (ActivityMonth) {
      this.setState({ loading: true });

      fetchApi(
        `/regular-reports/data-entry-emasculation?month=${ActivityMonth}&block.uuid=${block_uuid}`,
        "get"
      ).then(res => {
        if (res)
          this.setState({
            // data: cloneDeep(this.state.ActivityMonth)
            //   ? res.blocks
            //     ? res
            //     : null
            //   : null
            data: parseData(res)
          });
        else message.error("Internal Server Error!");
        this.setState({ loading: false });
      });
    }
  };

  fetchBlockNo = () =>
    fetchApi("/blocksuuid", "get").then(data =>
      this.setState({ blockNoList: sortFunction(data, "blockNoFull") })
    );

  onBlockChangeHandler = it => {
    // if (!this.state.ActivityMonth) {
    //   message.info("Select Activity Month");
    //   this.setState({
    //     blockNumber: null,
    //     block_uuid: null
    //   });
    // } else {

    this.setState(
      {
        blockNumber: it ? it : null,
        block_uuid: it
          ? cloneDeep(this.state.blockNoList).filter(
              each => each.blockNoFull === it
            )[0].uuid
          : null
      },
      () => this.fetchDataEntryEmasculation()
    );
    //}
  };

  activityMonthHandler = date => {
    if (date) {
      this.setState(
        {
          ActivityMonth: date.format("YYYY-MM")
        },
        () => this.fetchDataEntryEmasculation()
      );
    } else {
      this.setState({
        ActivityMonth: null,
        blockNumber: null,
        block_uuid: null,
        data: null
      });
    }
  };

  generateExcel = () => {
    let { block_uuid, ActivityMonth } = this.state;
    fetchExcelApi(
      `/regular-reports/data-entry-emasculation?month=${ActivityMonth}&block.uuid=${block_uuid}`,
      "get"
    ).then();
  };

  render() {
    let { data, loading, ActivityMonth, blockNoList, blockNumber } = this.state;
    const columns = [
      {
        title: "Date Of Emasculation",
        //dataIndex: "dt_emasculation",
        render: it =>
          it.dt_emasculation
            ? it.dt_emasculation.length > 10
              ? {
                  children: it.dt_emasculation,

                  props: {
                    colSpan: 6
                  }
                }
              : it.dt_emasculation == "Total"
              ? it.dt_emasculation
              : formatDate(it.dt_emasculation)
            : "-"
      },
      {
        title: "Total No. Of Good spathes",
        //dataIndex: "good_spathes",
        render: it =>
          it.dt_emasculation.length > 10
            ? {
                props: {
                  colSpan: 0
                }
              }
            : it.good_spathes
            ? it.good_spathes
            : "0"
      },
      {
        title: "Total No. Of P/M spathes",
        //dataIndex: "premature_spathes",
        render: it =>
          it.dt_emasculation.length > 10
            ? {
                props: {
                  colSpan: 0
                }
              }
            : it.premature_spathes
            ? it.premature_spathes
            : "0"
      },
      {
        title: "Dates Of Starting",
        //dataIndex: "start_date",
        render: it =>
          it.dt_emasculation.length > 10
            ? {
                props: {
                  colSpan: 0
                }
              }
            : it.dt_emasculation == "Total"
            ? {
                props: {
                  colSpan: 1
                }
              }
            : it.start_date
            ? formatDate(it.start_date)
            : "-"
        //render: it => (it ? formatDate(it) : "-")
      },
      {
        title: "Date Of Ending",
        //dataIndex: "end_date",
        //render: it => (it ? formatDate(it) : "-")
        render: it =>
          it.dt_emasculation.length > 10
            ? {
                props: {
                  colSpan: 0
                }
              }
            : it.dt_emasculation == "Total"
            ? {
                props: {
                  colSpan: 1
                }
              }
            : it.end_date
            ? formatDate(it.end_date)
            : "-"
      },
      {
        title: "Last Update Date",
        //dataIndex: "last_update_date",
        //render: it => (it ? formatDate(it) : "-")
        render: it =>
          it.dt_emasculation.length > 10
            ? {
                props: {
                  colSpan: 0
                }
              }
            : it.dt_emasculation == "Total"
            ? {
                props: {
                  colSpan: 1
                }
              }
            : it.last_update_date
            ? formatDate(it.last_update_date)
            : "-"
      }
    ];
    let JSX =
      data && data.blocks ? (
        <MultiTable columns={columns} dataSource={data} type={"Emasculation"}/>
      ) : ActivityMonth ? (
        <Empty description="No Data Found" />
      ) : (
        <Empty description={"Select Activity Month"} />
      );
    const buttonList =
      data && data.blocks
        ? [
            {
              label: "Excel",
              icon: "file-text",
              onClickHandler: () => this.generateExcel()
            },
            {
              label: "Print",
              icon: "diff",
              reference: this.componentRef
            }
          ]
        : null;
    return (
      <ReportLayout
        title="Data Entry Status Report Emasculation"
        buttonList={buttonList}
        dropDownList={[
          {
            label: "Block",
            listItems: cloneDeep(blockNoList).map(it => it.blockNoFull),
            value: blockNumber ? blockNumber : undefined,
            changeHandler: it => this.onBlockChangeHandler(it)
          },
          {
            label: "Activity Month",
            type: "month",
            //value: ActivityMonth ? ActivityMonth : undefined,
            changeHandler: this.activityMonthHandler
          }
        ]}
      >
        <div ref={this.componentRef}>
          <Spin spinning={loading} size="large">
            {JSX}
          </Spin>
        </div>
      </ReportLayout>
    );
  }
}

export default DataEntryStatusReportEmasculation;
